import "../style.css";

function UpperTextMiddleAnchor({ text, posx, posy, fontSize, textColor = "white" }) {
  return (
    <div
      className="container-component-upper-text-middle-anchor"
      style={{
        top: `${posy}%`,
        left: `${posx}%`,
        transform: "translate(-50%, -50%)", // Adjust for centering by middle
        fontSize: fontSize,
        color: textColor,
        position: "absolute",
        zIndex: 1000,
      }}
    >
      <span
        className="unit"
        style={{
          fontSize: fontSize,
        }}
      >
        {text}
      </span>
    </div>
  );
}

export default UpperTextMiddleAnchor;